<!--登录-->
<template>
  <div class="main">
    <div class="info-box">
      <div class="top-line"></div>
      <div class="info-content">
        <div class="title">请使用答题验证码</div>
        <Form class="form-box" ref="loginFromRef" :model="loginFrom" :rules="loginFromRules" inline>
          <Form-item prop="code">
            <Input type="text" v-model="loginFrom.code" placeholder="请输入验证码">
              <i class="iconfont iconxiaoxi1" slot="prepend"></i>
            </Input>
          </Form-item>
          <Form-item>
            <div class="submitBtn" @click="handleSubmit('loginFromRef')">下一步</div>
          </Form-item>
        </Form>
      </div>
    </div>
    <div class="info-btn"></div>
    <img class="login-user" src="../../assets/images/login_r.png" alt="" v-if="isRenBj">

    <LoginCodeDialog :status="loginCodeDialogStatus" @callback="loginCodeCallback"/>
  </div>
</template>

<script>
import {cmsLogin, formDetail, formSetting} from "../../api/Interface";
import LoginCodeDialog from "../../components/LoginCodeDialog";
    export default {
        name: "code",
      components:{
          LoginCodeDialog
      },
        data() {
            return {
                loginCodeDialogStatus:false,
                docmHeight: document.documentElement.clientHeight || document.body.clientHeight,
                showHeight: document.documentElement.clientHeight || document.body.clientHeight,
                isRenBj: true,
                loginFrom: {
                    code: '',
                },
                loginFromRules: {
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                    ]
                }
            }
        },
        created() {
          this.getLogin()
        },
        mounted() {
            //监听事件
            window.onresize = () => {
                return (() => {
                    this.showHeight = document.documentElement.clientHeight || document.body.clientHeight;
                })()
            }
        },
        methods: {
          //获取登录信息
          getLogin(){
            let _this=this
            let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
            if (ua.match(/mediacloudclient/i) == 'mediacloudclient') {
              this.getUrlParams()
              formSetting(this.$route.query.id).then(res => {
                if (res.state) {
                  this.$store.commit('settingData', res.data);
                  //判断是否需要登录
                  if (res.data.base.login_limit) {
                    //需要登录
                    if(res.data.base.login_code_limit&&this.$store.state.loginCode==''){
                      this.loginCodeDialogStatus = true;
                      return;
                    }
                    // 在app内打开
                    mc.userGetEncryptInfo(function (data) {
                      //已登录
                      if (data.state == 1) {
                        let params={
                          userid:data.data.userid,
                          timestamp:data.data.timestamp,
                          nonce:data.data.nonce,
                          sign:data.data.signature,
                          form_id:_this.$route.query.id
                        }
                        cmsLogin(params).then(res => {
                          if (res.state) {
                          } else {
                            _this.$Message.error(res.error);
                          }
                        }).catch(error => {
                          console.log(error);
                        })
                      } else if (data.state == 0) {
                        // 未登录
                        mc.userLogin(function (data) {
                          if (data.state == 1) {
                            mc.userGetEncryptInfo(function (data2) {
                              if (data2.state == 1) {
                                let params={
                                  userid:data2.data.userid,
                                  timestamp:data2.data.timestamp,
                                  nonce:data2.data.nonce,
                                  sign:data2.data.signature,
                                  form_id:_this.$route.query.id
                                }
                                cmsLogin(params).then(res => {
                                  if (res.state) {
                                  } else {
                                    _this.$Message.error(res.error);
                                  }
                                }).catch(error => {
                                  console.log(error);
                                })
                              }
                            });
                          }
                        });
                      }
                    });
                  }else{
                    return false
                  }
                }
              })
            }else{
              if(this.$store.state.settingData.base.login_code_limit&&this.$store.state.loginCode==''){
                this.loginCodeDialogStatus = true;
                return;
              }
            }
          },
            //获取详情
            getFormDetail() {
                let data = {
                    form_id: this.$route.query.id,
                    code: this.$store.state.code
                }
                formDetail(data).then(res => {
                    if (res.state) {
                      //  form_type = 3 跳党建答题皮肤页
                      if(this.$store.state.settingData.form_type === 3){
                        this.$router.push('/skin?id=' + this.$route.query.id)
                      }else {
                        this.$router.push('/explain?id=' + this.$route.query.id)
                      }
                    } else {
                        this.$Message.error(res.error)
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            //登录按钮
            handleSubmit(ref) {
                this.$refs[ref].validate((valid) => {
                    if (valid) {
                        this.$store.commit('code', this.loginFrom.code)
                        this.getFormDetail()
                    }
                })
            },
          loginCodeCallback(){
            this.loginCodeDialogStatus = false;
          },
          //获取网址参数
          getUrlParams() {
            var url = window.location.href; //获取当前url
            var cs = url.split('?')[1];//获取?之后的参数字符串
            var cs_arr = cs.split('&');//参数字符串分割为数组
            var cs = {};
            for (var i = 0; i < cs_arr.length; i++) {//遍历数组，拿到json对象
              cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
            }
            if(!this.$route.query.id){
              this.$store.commit('formId', cs.id);//这样就拿到了参数中的数据
            }
          },
        },
        watch: {
            //监听显示高度
            showHeight: function () {
                if (this.docmHeight > this.showHeight) {
                    //隐藏
                    this.isRenBj = false
                } else {
                    //显示
                    this.isRenBj = true
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
  .main {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    background: url("../../assets/images/bj_img.png") no-repeat center;
    background-size: cover;
    padding: 50px 10px 0 10px;

    .info-box {
      position: relative;
      z-index: 999;

      .top-line {
        height: 20px;
        background: #1a4bff;
        border: 4px solid #256eff;
        border-radius: 11px;
        box-shadow: 0 3px 6px 0 rgba(0, 53, 157, 0.62);
      }

      .info-content {
        height: 290px;
        background: url("../../assets/images/duan0.png") no-repeat;
        padding: 20px 30px 0 30px;
        background-size: 100% 100%;
        margin-top: -23px;

        .title {
          font-size: 20px;
          color: #303133;
          text-align: center;
          font-weight: bold;
          height: 68px;
          line-height: 68px;
        }

        .form-box {
          height: calc(100% - 68px);
          padding-top: 45px;

          .ivu-form-item-error {
            /deep/ .ivu-input {

              &:focus {
                box-shadow: none;
                border-color: #ed4014 !important;
              }
            }
          }

          .btn {
            display: flex;
            color: #3559E0;
            align-items: center;
            font-size: 12px;
            border-left: 1px solid #D2D6EB;
            padding-left: 10px;

            .iconfont {
              font-size: 18px !important;
              margin-right: 5px;
            }
          }


          .ivu-form-item {
            width: 100%;
            margin-bottom: 35px;

            .ivu-input-group {
              height: 45px;

              /deep/ .ivu-input-group-prepend {
                background-color: transparent;

              }

              /deep/ .ivu-input {
                height: 45px;
                border-left: none !important;
                outline: none !important;
                -webkit-appearance: none; /*去除系统默认的样式*/
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/

                &:focus {
                  box-shadow: none;
                  border-color: #dcdee2;
                }
              }

              .iconfont {
                font-size: 22px;
              }

              /deep/ .ivu-input-group-append {
                background-color: transparent;
                border-left: none !important;
              }
            }

            .yzm {
              /deep/ .ivu-input {
                border-right: none !important;
              }
            }
          }
        }

        .submitBtn {
          width: 170px;
          height: 62px;
          display: block;
          border-radius: 18px;
          background: url("../../assets/images/btn_y.png") no-repeat;
          font-size: 20px;
          line-height: 62px;
          color: #fff;
          background-size: cover;
          text-align: center;
          margin: 30px auto 0 auto;
        }
      }
    }
  }

  .login-user {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 40%;
    z-index: 0;
  }
</style>
